<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">用户id：</div>
        <el-input v-model="filters.suid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item" v-if="0">
        <div class="filter__name">购买类型：</div>
        <el-select class="filter__input" size="mini" v-model="filters.purchase">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in purchaseList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item" v-if="0">
        <el-checkbox v-model="filters.owner">屏蔽自家人</el-checkbox>
      </div>
    </div>
    <div class="flex jce mt-20">
      <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in statusList" :key="index" @click="changeStatus(index)">{{item.name}}</button>
    </div>
    <div class="flex jcb mt-20" v-if="filters.status === 0 || filters.status === 4">
      <div class="flex aic">
        <div class="mr-20">选择支付宝：</div>
        <el-radio-group v-model="pay_account">
          <el-radio :label="1" border size="small">极推支付宝</el-radio>
          <el-radio :label="2" border size="small">有只喵支付宝</el-radio>
        </el-radio-group>
      </div>
      <div>
        <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in handleList" :key="index" @click="changeHandle(index)">{{item.name}}</button>
        <button class="blue-small-btn ml-10" @click="shopExchangeUpdate">提交</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600" :summary-method="getSummaries" show-summary>
      <el-table-column prop="erid" label="兑换ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="suid" label="用户" width="" align="center">
        <template slot-scope="scope">
          <router-link :to="{path: '/shopUserDetail', query: {suid: scope.row.suid}}">{{scope.row.nickname}}({{scope.row.suid}})</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="pay_account" label="支付账户" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.pay_account == 2">有只喵支付宝</div>
          <div v-if="scope.row.pay_account == 1">极推支付宝</div>
          <div v-if="scope.row.pay_account == 0">个人号</div>
        </template>
      </el-table-column>
      <el-table-column prop="user" label="真实名字" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('suid', scope.row.suid)">{{scope.row.alipay_name}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="等级" width="" align="center">
      </el-table-column>
      <el-table-column prop="alipay" label="支付宝" width="" align="center">
      </el-table-column>
      <el-table-column prop="cost" label="兑换金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="balance" label="兑换前余额" width="" align="center">
      </el-table-column>
      <el-table-column prop="current_balance" label="当前余额" width="" align="center">
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="last_edit" label="编辑时间" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.last_edit)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="状态" width="120" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 4">兑换失败</div>
          <div v-if="scope.row.status == 3">兑换成功</div>
          <div v-if="scope.row.status == 2">拒绝兑换</div>
          <div v-if="scope.row.status == 1">审核通过</div>
          <div v-if="scope.row.status == 0">等待审核</div>
        </template>
      </el-table-column>
      <el-table-column prop="response" label="结果" width="140" align="center" v-if="filters.status === 4">
      </el-table-column>
      <el-table-column prop="" label="操作" width="160" fixed="right" align="center" v-if="filters.status === 0 || filters.status === 4">
        <template slot-scope="scope">
          <div>
            <el-radio-group v-model="scope.row.isChoose">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="0">拒绝</el-radio>
            </el-radio-group>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog
      title="创建收支请款记录"
      :visible.sync="handDialogVisible"
      width="30%"
      center>

      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">兑换ID:</div>
            <div class="">{{exchange_info.eid}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">用户:</div>
            <div class="">{{exchange_info.nickname}}({{exchange_info.suid}})</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">请款金额:</div>
            <div class="">{{exchange_info.amount}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name ml40">收款二维码</div>
            <div class="headimg-container relative" style="width:250px">
              <uploadHeadImage :url.sync="exchange_info.account" :itype="5"></uploadHeadImage>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-20">
        <span>是否选择手动打款，确定后将需要去收支列表打款</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editHand">确 定</el-button>
      </span>
    </el-dialog>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {shopExchangeLists, shopExchangeUpdate} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'shopExchange',
  mixins: [mixinList],
  components: {
    uploadHeadImage
  },
  data () {
    return {
      lists: [],
      listLoading: false,
      dialogVisible: false,
      handDialogVisible: false,
      filters: {
        p: 1,
        l: 20,
        status: '',
        total: 0,
        suid: '',
        purchase: '',
        owner: false
      },
      detail: {
        eid: '',
        remark: ''
      },
      pay_account: 1,
      exchange_info: {
        eid: '',
        suid: '',
        nickname: '',
        title: '',
        amount: '',
        account: ''
      },
      // 状态按钮
      statusList: [
        {
          name: '所有',
          value: '',
          status: 1
        },
        {
          name: '等待审核',
          value: 0,
          status: 0
        },
        {
          name: '审核通过',
          value: 1,
          status: 0
        },
        {
          name: '拒绝兑换',
          value: 2,
          status: 0
        },
        {
          name: '兑换成功',
          value: 3,
          status: 0
        },
        {
          name: '兑换失败',
          value: 4,
          status: 0
        }
      ],
      purchaseList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '需要返款',
          value: 0
        },
        {
          name: '囤货',
          value: 3
        }
      ],
      // 操作按钮
      handleList: [
        {
          name: '全部通过',
          value: 1,
          status: 0
        },
        {
          name: '全部拒绝',
          value: 2,
          status: 0
        }
      ]
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    conditionChange () {
      this.filters.p = 1
      this.getList()
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['amount', 'payment', 'commission', 'final_payment', 'agency_fees'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
    },
    getList () {
      let filters = this.filters
      let params = {
        // status: filters.status,
        p: filters.p,
        l: filters.l
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      if (filters.suid !== '') {
        params.suid = filters.suid
      }
      if (filters.purchase !== '') {
        params.purchase = filters.purchase
      }
      if (filters.owner === true) {
        params.owner = 1
      }
      this.listLoading = true
      shopExchangeLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    shopExchangeUpdate (success = '') {
      let lists = this.lists
      let accept = []
      let reject = []
      lists.forEach((item) => {
        if (item.isChoose === 1) {
          accept.push(item.eid)
        }
        if (item.isChoose === 0) {
          reject.push(item.eid)
        }
      })

      let params = {
        pay_account: this.pay_account,
        accept: accept.join('|'),
        reject: reject.join('|')
      }

      if (success !== '') {
        params.success = success
        params.account = this.exchange_info.account
      }

      shopExchangeUpdate(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.handDialogVisible = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value

      this.filters.p = 1
      this.getList()
    },
    displayHandDialog (index, eid) {
      this.detail.eid = eid
      this.handDialogVisible = true
      this.lists.forEach((item) => {
        item.isChoose = ''
      })

      for (let key in this.exchange_info) {
        this.exchange_info[key] = this.lists[index][key]
      }
      this.exchange_info.account = ''
    },
    editHand (eid) {
      if (this.exchange_info.account === '') {
        this.$notify({
          title: '收款二维码没有传',
          type: 'error'
        })
        return
      }
      this.shopExchangeUpdate(this.detail.eid)
      this.handDialogVisible = false
    },
    changeHandle (index) {
      this.handleList.forEach(item => {
        item.status = 0
      })
      this.handleList[index].status = 1
      switch (this.handleList[index].value) {
        case 1: // 全部通过
          this.lists.forEach((item) => {
            item.isChoose = 1
          })
          break
        case 2: // 全部拒绝
          this.lists.forEach((item) => {
            item.isChoose = 0
          })
          break
      }
    }
  },
  mounted () {
    this.changeStatus(1)
    // this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.suid': 'conditionChange',
    'filters.purchase': 'conditionChange',
    'filters.owner': 'conditionChange'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopExchange.vue